import { gql } from "@apollo/client";
import client from "../apolloClient";
import {
  DashboardData,
  SuperAdminDashboardData,
} from "../../schemas/dashboardSchema";

const GET_ACTIVE_SCREENS_DASHBOARD = gql`
  query ActiveScreensDashboard {
    activeScreensDashboard {
      barData {
        name
        value
      }
      offSinceData {
        name
        value
      }
      updateData {
        name
        value
      }
      pieDataCity {
        id
        name
        value
      }
      pieDataArea {
        id
        name
        value
      }
      cityBreakdown {
        cityId
        cityName
        totalScreens
        onScreens
        offScreens
        regions {
          regionId
          regionName
          totalScreens
          onScreens
          offScreens
        }
      }
    }
  }
`;

const GET_SUPER_ADMIN_DASHBOARD = gql`
  query SuperAdminDashboard {
    superAdminDashboard {
      totalTenants
      premiumTenants
      nonPremiumTenants
      deletedTenants
      tenantGrowthTrend {
        month
        count
      }
      tenants {
        id
        companyName
        address
        isPremium
        dbName
        createdAt
        isDeleted
      }
    }
  }
`;

export const dashboardService = {
  getActiveScreensDashboard: async (): Promise<DashboardData> => {
    const { data } = await client.query({
      query: GET_ACTIVE_SCREENS_DASHBOARD,
      fetchPolicy: "network-only",
    });
    return data.activeScreensDashboard;
  },

  getSuperAdminDashboard: async (): Promise<SuperAdminDashboardData> => {
    const { data } = await client.query({
      query: GET_SUPER_ADMIN_DASHBOARD,
      fetchPolicy: "network-only",
    });
    return data.superAdminDashboard;
  },
};
